/**
 * Populates the Race/Ethnicity dropdown menu for the personal details dataset
 * Adds validation for dataset templates
 */
 export const Forms = (function () {

    var init = function () {
        ds_personal_details.init();
        ds_home.init();
        setPageState();
    }

    // Personal Details dataset template
    var ds_personal_details = {
        init: function () {
            this.addRaceAndEthnicity();
            toggleLandlordOptions();
        },

        // Populates the race and ethnicity dropdown
        addRaceAndEthnicity: function () {
            // Only run if the field exists on the page
            var $select = $('#field_personal_ethnicityID');
            if (!$select.length) return;

            // 1) Remember whatever value the page/PDS has already put there
            //    (trim to be safe against stray spaces)
            var current = ($select.val() || '').trim();

            var promise = MRD.listings.getRaceEthnicity();
            promise.then(function (response) {
                // 2) Rebuild options
                $select.empty();

                var $frag = $(document.createDocumentFragment());
                var groups = new Map();

                function ensureGroup(id) {
                    id = String(id);
                    if (!groups.has(id)) {
                        var $og = $('<optgroup>', { id: id, label: '' });
                        groups.set(id, $og);
                        $frag.append($og);
                    }
                    return groups.get(id);
                }

                response.forEach(function (row) {
                    var id = String(row.id);
                    var pid = String(row.parent_id);

                    if (pid === '0') {
                        ensureGroup(id).attr('label', row.ethnicity);
                    } else {
                        ensureGroup(pid).append(
                            $('<option>', { value: row.ethnicity, text: row.ethnicity })
                        );
                    }
                });

                $select.append($frag);

                // 3) Restore previous selection if it exists and matches one of the new values
                if (current) {
                    // exact match on value (since you set value = ethnicity text)
                    var has = $select.find('option').filter(function () {
                        return $(this).val().trim() === current;
                    }).length;

                    if (has) {
                        $select.val(current).trigger('change');
                    } else {
                        // leave placeholder selected
                        $select.val('');
                    }
                } else {
                    // No previous value: leave placeholder selected
                    $select.val('');
                }
            });
        }
    }

    // Home dataset template
    var ds_home = {
        init: function () {
            toggleLandlordOptions();
            this.toggleMaidenName();
        },

        // Toggles the Maiden Name option from being displayed if Title selected is "Mr"
        toggleMaidenName: function () {
            $('#field_personal_titleID').change(function () {
                if ($(this).val() == "Mr") {
                    $('#field_personal_manameID').parent().hide();
                }
                else {
                    $('#field_personal_manameID').parent().show();
                }
            })
        }
    }
    
    // Toggles the landlord options from being displayed if tenancy type is "Owner Occupier"
    function toggleLandlordOptions() {
        $('#field_home_tenancyID').change(function () {
            if ($(this).val() == "Owner Occupier") {
                $('#field_home_owner_streetID').parent().hide();
                $('#field_home_owner_townID').parent().hide();
                $('#field_home_owner_countyID').parent().hide();
                $('#field_home_owner_postcodeID').parent().hide();
                $('#field_home_owner_countryID').parent().hide();
            }
            else {
                $('#field_home_owner_streetID').parent().show();
                $('#field_home_owner_townID').parent().show();
                $('#field_home_owner_countyID').parent().show();
                $('#field_home_owner_postcodeID').parent().show();
                $('#field_home_owner_countryID').parent().show();
            }
        })
    }

    // Required due to when the values of the options are loaded from the PDS
    // Checks if these options have already been filled out and does the processing required
    function setPageState() {
        $(window).on('pageshow', function () {
            setTimeout(function () {
                if ($('#field_personal_titleID option:selected').val() != "Mr") {
                    $('#field_personal_manameID').parent().show();
                } else {
                    $('#field_personal_manameID').parent().hide();
                }

                if ($('#field_home_tenancyID option:selected').val() != "Owner Occupier") {
                    $('#field_home_owner_streetID').parent().show();
                    $('#field_home_owner_townID').parent().show();
                    $('#field_home_owner_countyID').parent().show();
                    $('#field_home_owner_postcodeID').parent().show();
                    $('#field_home_owner_countryID').parent().show();
                } else {
                    $('#field_home_owner_streetID').parent().hide();
                    $('#field_home_owner_townID').parent().hide();
                    $('#field_home_owner_countyID').parent().hide();
                    $('#field_home_owner_postcodeID').parent().hide();
                    $('#field_home_owner_countryID').parent().hide();
                }
            }, 1000);

        })
    }
    return {
        init: init
    }
}());
